/** Values stored or returned by API — keep for comparisons and payloads. */
export const API_GROUP_WORKOUT_COMMENT = 'Групповая тренировка';
/** API client_nickname for trainer-only (self) workouts — must match backend expectations. */
export const API_SELF_WORKOUT_NICKNAME = 'Самотрен';
export const API_LOCATION_ONLINE_LABEL = 'Онлайн';
